import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import homework_V2 from './../../services/homework_V2.service';
import models_V2Service from './../../services/models_V2.service';
import ComponentTable from '../../components/ComponentTable';
import BackButton from '../../components/BalanceComponent/BackButton';

export default function HomeworkCyclesStats() {
    const { t } = useTranslation();
    const { id, student_id } = useParams();

    return (
        <Fragment>
            <BackButton to={id ? `/groups/${id}` : `/students`} label={id ? t('sidebar.groups') : t('userBankSorobanPage.students')} />
            <h2 className="container-header">{t('groups.completedHwCyclesCount')}</h2>
            <ComponentTable
                source={{
                    getData: (page, size, sort, filter) =>
                        homework_V2.getHomeworkCyclesStats(false, {
                            student_id: student_id,
                            page: page || 0,
                            size: size || 10,
                            orderBy: (sort && sort.orderBy) || null,
                            order: (sort && sort.order) || 'asc',
                            filter,
                        }),
                    getModel: () => models_V2Service.GetHomeworkCyclesStats(false),
                }}
                actions={[]}
                selectable={true}
                title={t('modals.list')}
                enableSettings
                toolbarvisible={true}
                typeTable="homeworkCyclesStats"
            />
            </Fragment>
    );
}
